import React from "react";
import PropTypes from "prop-types";
import SelectField from "venuescanner-js/react/components/SelectField/SelectField";

const budgetOptions = [
  { label: "Under £250", value: [0, 250] },
  { label: "£250 to £500", value: [250, 500] },
  { label: "£500 to £1,000", value: [500, 1000] },
  { label: "£1,000 to £3,000", value: [1000, 3000] },
  { label: "£3,000 to £6,000", value: [3000, 6000] },
  { label: "£6,000 to £12,000", value: [6000, 12000] },
  { label: "£12,000 to £24,000", value: [12000, 24000] },
  { label: "£25,000 to £50,000", value: [25000, 50000] },
  { label: "Over £50,000", value: [50000, 1000000] },
  { label: "Sky's the Limit!", value: [undefined, undefined] },
];

const BudgetRange = ({ onChange }) => (
  <SelectField
    options={budgetOptions}
    onChange={({ value }) => onChange(value)}
  />
);

BudgetRange.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array.isRequired,
};

export default BudgetRange;
